// (function () {
//     'use strict';

//     var module = angular.module("imApp");

//     module.factory("multiDocService", ['$q', '$ihttp', function ($q, $ihttp) {
//         var service = {
//             loaded: false,
//             p2WMultiDocList: {
//                 records: []
//             },
//             loadP2WMultiDocList: function (doctype, argtype, argvalue) {
//                 var deferred = $q.defer();

//                 var parmsP2WMultiDocList = {
//                     method: 505,
//                     parameters: {
//                         doctype: doctype,
//                         argtype: argtype,
//                         argvalue: argvalue
//                     }
//                 };

//                 $ihttp.post(parmsP2WMultiDocList).then(function (data) {
//                     angular.copy(data, service.p2WMultiDocList.records);
//                     service.loaded = true;
//                     deferred.resolve();
//                 });

//                 return deferred.promise;
//             }
//         };

//         return service;
//     }]);
// })();
